import { Route, Routes, Navigate } from 'react-router-dom';
import { AuthRoute } from '@omnigenbiodata/ui';
import ROUTES from '../core/constants/routes.constants';

import AuthScene from './AuthScene';
import Login from './AuthScene/scenes/Login';
import MultiFactor from './AuthScene/scenes/MultiFactor';
import NewPassword from './AuthScene/scenes/NewPassword';
import ResetPassword from './AuthScene/scenes/ResetPassword';
import SubmitResetPassword from './AuthScene/scenes/SubmitResetPassword';
import Logout from './AuthScene/scenes/Logout';

import PortalScene from './PortalScene';
import HomeScene from './PortalScene/scenes/HomeScene';
import ParticipantsScene from './PortalScene/scenes/ParticipantsScene';
import ParticipantsListScene from './PortalScene/scenes/ParticipantsScene/scenes/ParticipantsListScene';
import ParticipantScene from './PortalScene/scenes/ParticipantsScene/scenes/ParticipantScene';
import SitesScene from './PortalScene/scenes/SitesScene';
import SitesListScene from './PortalScene/scenes/SitesScene/scenes/SitesListScene';
import SiteScene from './PortalScene/scenes/SitesScene/scenes/SiteScene';

function Scenes() {
  return (
    <Routes>
      <Route path={ROUTES.auth} element={<AuthScene />}>
        <Route path={ROUTES.auth} element={<Login />} />
        <Route path={ROUTES.authMfa} element={<MultiFactor />} />
        <Route path={ROUTES.authNewPassword} element={<NewPassword />} />
        <Route path={ROUTES.authResetPassword} element={<ResetPassword />} />
        <Route path={ROUTES.authSubmitResetPassword} element={<SubmitResetPassword />} />
        <Route path={ROUTES.authSignOut} element={<Logout />} />
      </Route>
      <Route path={ROUTES.root} element={<AuthRoute path={ROUTES.root} element={PortalScene} />}>
        <Route path={ROUTES.root} element={<HomeScene />} />
        <Route path={ROUTES.portalParticipants} element={<ParticipantsScene />}>
          <Route path={ROUTES.portalParticipants} element={<ParticipantsListScene />} />
          <Route path={ROUTES.portalParticipant} element={<ParticipantScene />} />
        </Route>
        <Route path={ROUTES.portalSites} element={<SitesScene />}>
          <Route path={ROUTES.portalSites} element={<SitesListScene />} />
          <Route path={ROUTES.portalSite} element={<SiteScene />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to={ROUTES.root} replace />} />
    </Routes>
  );
}

export default Scenes;
